"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasSomeOfGivenStateWasteCodes = hasSomeOfGivenStateWasteCodes;
const stateWasteCodeNormalization_1 = require("encamp-shared/dist/waste/stateWasteCodeNormalization");
/** Whether any of the container's state codes is one of `codes`, in canonical bare form. */
function hasSomeOfGivenStateWasteCodes(container, codes) {
    if (container.stateWasteCodes === undefined) {
        return { missing: ["container.stateWasteCodes"] };
    }
    return {
        value: container.stateWasteCodes.some((code) => {
            const normalized = (0, stateWasteCodeNormalization_1.normalizeStateWasteCode)(code)?.toUpperCase();
            return normalized !== undefined && codes.includes(normalized);
        }),
    };
}
//# sourceMappingURL=stateWasteCodes.js.map